<template>
  <div>
    <div v-if="loaded">
      <AuthorizedLayout v-if="currentUser" />
      <NotAuthorizedLayout v-else />
    </div>
    <div v-else>
      <Spinner :relative="false" />
    </div>
  </div>
</template>

<script>
import AuthorizedLayout from "./layouts/authorized.layout";
import NotAuthorizedLayout from "./layouts/not-authorized.layout";
import { mapState } from "vuex";
export default {
  name: "App",
  components: { AuthorizedLayout, NotAuthorizedLayout },
  metaInfo: {
    title: "Commons Admin",
    titleTemplate: (titleChunk) => {
      return titleChunk && titleChunk !== "Commons Admin"
        ? `${titleChunk} | Commons Admin`
        : "Commons Admin";
    },
  },
  created() {
    this.$moment.locale("en");
    this.init();
  },
  methods: {
    async init() {
      await this.$store.dispatch("application/init");
    },
  },
  computed: {
    ...mapState({
      loaded: (state) => state.application.loaded,
    }),
  },
};
</script>
